import React, { useEffect } from "react";

/**
 * Tawk.to live chat widget. Activates when REACT_APP_TAWK_PROPERTY_ID is set
 * in the frontend .env. Until configured, renders nothing (no-op).
 *
 * Setup:
 * 1. Sign up at https://www.tawk.to (free)
 * 2. Copy your property ID + widget ID from the embed code
 * 3. Set REACT_APP_TAWK_PROPERTY_ID="<propertyId>/<widgetId>" in frontend/.env
 */
const TawkChat = () => {
  useEffect(() => {
    const id = process.env.REACT_APP_TAWK_PROPERTY_ID;
    if (!id) return undefined;
    if (window.Tawk_API) return undefined;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://embed.tawk.to/${id}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    s.setAttribute("data-testid", "tawk-script");
    document.head.appendChild(s);
    return () => {
      s.remove();
    };
  }, []);
  return null;
};

export default TawkChat;
